import * as React from 'react';
import { useParams } from 'react-router';

export interface IToolIFrameProps {
}

export default function ToolIFrame(props: IToolIFrameProps) {
    const [frameUrl, setFrameUrl] = React.useState<string | null>(null);
    const params = useParams();
    const iframeRef = React.useRef<HTMLIFrameElement>(null);
    const getFrameUrl = async () => {
        if (params['id'] === '1')
            setFrameUrl('http://localhost:8080/entry/viewer');
        else if (params['id'] === '2')
            setFrameUrl('https://validator.sudop-group.cz');
    };
    React.useEffect(() => {
        getFrameUrl();
    }, [params]);
    React.useEffect(() => {
        const handleMessage = (event: MessageEvent) => {
            if (event.data.type === 'initialized') {
                console.log('Iframe message system initialized');
                if (iframeRef.current) {
                    // iframeRef.current.onload = () => {
                    //     console.log
                    //     ('Iframe loaded');
                    iframeRef.current?.contentWindow?.postMessage({ type: 'login', data: { token: localStorage.getItem('token'), refresh: localStorage.getItem('refresh_token') } }, '*');
                    // };
                }
                // You can perform additional actions here if needed    
            }
        };

        window.addEventListener('message', handleMessage);

        return () => {
            window.removeEventListener('message', handleMessage);
        };
    }, []);

    
    return (
        <div style={{ width: '100%', height: '99vh' }}>
            {frameUrl && <iframe
                title='tool'
                ref={iframeRef}
                width={'100%'}
                height={'100%'}
                style={{ border: 0 }}
                src={frameUrl}></iframe>}
        </div >
    );
}
